export default "__VITE_ASSET__Bt5Beorp__"